import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const alertRaise = async (alertId: string): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/alert-management/alerts/${alertId}/raise`,
    method: 'POST',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  await emeraldRequest(emeraldRequestParams);
};
